export enum PkiConnectivityState {
  OK = "OK",
  KO = "KO",
}
